import * as React from "react";
import clsx from "clsx";

export type WindowChromeProps = {
  title: string;
  fullscreen?: boolean;
  draggable?: boolean;
  onMinimize?: () => void;
  onToggleFullscreen?: () => void;
  onClose?: () => void;
  onTitleClick?: () => void;
  onHandlePointerDown?: (e: React.PointerEvent) => void;
};

/**
 * Banana title bar with a Space Mono app-name and three square controls,
 * top-right (Windows order): green = minimize, gold = fullscreen, red = close.
 */
export const WindowChrome: React.FC<WindowChromeProps> = ({
  title,
  fullscreen,
  draggable,
  onMinimize,
  onToggleFullscreen,
  onClose,
  onTitleClick,
  onHandlePointerDown,
}) => (
  <div
    className={clsx("winbar", { "winbar--draggable": draggable })}
    onPointerDown={onHandlePointerDown}
  >
    <span className="winbar-title" onClick={onTitleClick}>
      {title}
    </span>
    {/* Stop pointerdown here so clicking a control never starts a window drag */}
    <div
      className="winbar-controls"
      onPointerDown={(e) => e.stopPropagation()}
    >
      {onMinimize && (
        <button
          type="button"
          className="winbtn winbtn--min"
          aria-label="Minimize"
          title="Minimize"
          onClick={onMinimize}
        />
      )}
      {onToggleFullscreen && (
        <button
          type="button"
          className="winbtn winbtn--full"
          aria-label={fullscreen ? "Restore" : "Maximize"}
          title={fullscreen ? "Restore" : "Maximize"}
          onClick={onToggleFullscreen}
        />
      )}
      {onClose && (
        <button
          type="button"
          className="winbtn winbtn--close"
          aria-label="Close"
          title="Close"
          onClick={onClose}
        />
      )}
    </div>
  </div>
);
